import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  styled,
  Tooltip,
  Typography,
  TypographyProps,
} from '@mui/material';
import dayjs from 'dayjs';
import { FeatureEnum } from '../../../../../services/data/impl/cube/cubeSlice';
import { Scan } from '../../../../../services/entities/impl/blfApi/schemas/scan';
import { DiagnosticFeature } from '../../../../commonUI/viewMode/DiagnosticFeature';
import ScanCardDeleteButton from './ScanCardDeleteButton';
import { ScanStatusIndicator } from './ScanStatusIndicator';

type Props = {
  scan: Scan;
  onClick: (scan: Scan, feature?: FeatureEnum) => void;
};

export const ScanCard = ({ scan, onClick }: Props) => {
  return (
    <Card
      sx={{
        minWidth: '90px',
        minHeight: '100px',
      }}
      variant='outlined'
      elevation={0}
    >
      <CardActionArea onClick={() => onClick(scan)}>
        <CardContent sx={{ position: 'relative' }}>
          <Stack
            direction='row'
            justifyContent='space-between'
            alignItems='center'
          >
            <Tooltip placement='top' title={scan.blockName}>
              <Typography noWrap sx={{ fontSize: '1rem', fontWeight: 600 }}>
                {scan.blockName}
              </Typography>
            </Tooltip>
            <ScanStatusIndicator scan={scan} />
          </Stack>
          <ScanCardSubtitle>
            {dayjs(scan.scanDate).format('MM/DD/YYYY')}
          </ScanCardSubtitle>
          <ScanCardSubtitle>{scan.ranchName}</ScanCardSubtitle>
          <DiagnosticFeature>
            <Box sx={{ position: 'absolute', bottom: 1, right: 1 }}>
              <ScanCardDeleteButton scanId={scan.id} />
            </Box>
          </DiagnosticFeature>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

const ScanCardSubtitle = styled((props: TypographyProps) => (
  <Typography variant='subtitle1' {...props} noWrap />
))(({ theme }) => ({
  color: theme.vars.palette.text.secondary,
  fontSize: '0.75rem',
  fontWeight: 400,
}));
